/**
 * IMPORTS
 */
import {gql} from '@apollo/client';


/**
 * TYPES
 */
import {ISubscription} from 'src/services/graphis/index.d';


/**
 * EXPORTS
 */

/**
 * I am a subscription to receive kanban updates.
 */
export const KANBAN_UPDATED: ISubscription<undefined> = {
    getTopic: () => 'kanban_updated',
    query: gql`
        subscription kanbanUpdated {
            kanbanUpdated {
                id
                name
                prio
                tag
            }
        }
    `,
};
